import apiUrl from "./config/config";
import axios from "axios";

class componentApi
{

  static async getComponents(params = {})
  {

    try
    {

      const response = await axios(apiUrl + "component", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  static async getComponentActions(params = {})
  {

    try
    {

      const response = await axios(apiUrl + "component/action", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

}




export default componentApi;
